import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSmartwatch1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSmartwatch1"><Path fillRule="evenodd" clipRule="evenodd" d="M7.45898 1H16.5401L17.5401 4H20V20H17.5401L16.5401 23H7.45898L6.45898 20H4V4H6.45898L7.45898 1ZM8.04012 4H15.959L15.459 2.5H8.54012L8.04012 4ZM8.04012 20L8.54012 21.5H15.459L15.959 20H8.04012ZM12.75 8V11.6893L14.5607 13.5L13.5 14.5607L11.25 12.3107V8H12.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSmartwatch1;
